import authService from "../../services/authService";
import { useState } from "react";

function PasswordManagementModal({ isOpen, onClose }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const resetState = () => {
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setError("");
    setSuccess("");
  };

  const handleClose = () => {
    resetState();
    onClose();
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError("Passwörter stimmen nicht überein");
      return;
    }
    if (newPassword.length < 8) {
      setError("Passwort muss mindestens 8 Zeichen lang sein");
      return;
    }
    setLoading(true);
    setError("");
    setSuccess("");
    try {
      const response = await authService.changePassword({
        currentPassword,
        newPassword,
        confirmNewPassword: confirmPassword,
      });

      if (!response.success) {
        setError(response.message || "Fehler beim Ändern des Passworts");
        return;
      }

      setSuccess(response.message || "Passwort erfolgreich geändert");
      setTimeout(handleClose, 2000);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.message ||
          "Fehler beim Ändern des Passworts",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-[100] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-brand-xl border border-pale-dawn w-full max-w-md overflow-hidden relative">
        <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50/50">
          <h2 className="text-xl font-bold text-gray-800 flex items-center">
            <i className="fas fa-lock mr-2 text-sunrise-red"></i>
            Change Password
          </h2>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 transition-colors bg-transparent border-0"
          >
            <i className="fas fa-times text-lg"></i>
          </button>
        </div>

        <div className="p-6">
          {error && (
            <div className="mb-4 bg-red-50 text-red-600 py-3 px-4 rounded-lg flex items-center text-sm border border-red-100">
              <i className="fas fa-exclamation-circle mr-2 flex-shrink-0"></i>
              <span>{error}</span>
            </div>
          )}
          {success && (
            <div className="mb-4 bg-green-50 text-green-700 py-3 px-4 rounded-lg flex items-center text-sm border border-green-100">
              <i className="fas fa-check-circle mr-2 flex-shrink-0"></i>
              <span>{success}</span>
            </div>
          )}

          <form onSubmit={handleChangePassword} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Current Password
              </label>
              <input
                type="password"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sunrise-red focus:border-sunrise-red transition-all outline-none"
                value={currentPassword}
                placeholder="Current password"
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                New Password
              </label>
              <input
                type="password"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sunrise-red focus:border-sunrise-red transition-all outline-none"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Min. 8 characters"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Confirm New Password
              </label>
              <input
                type="password"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sunrise-red focus:border-sunrise-red transition-all outline-none"
                value={confirmPassword}
                placeholder="Re-enter new password"
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>
            <div className="pt-2 flex flex-col gap-2">
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-sunrise-red hover:bg-red-700 text-white font-bold py-2.5 px-4 rounded-lg transition-colors flex items-center justify-center disabled:opacity-70"
              >
                {loading ? (
                  <i className="fas fa-circle-notch fa-spin"></i>
                ) : (
                  "Save Password"
                )}
              </button>
              <button
                type="button"
                onClick={handleClose}
                className="w-full bg-white hover:bg-gray-100 text-gray-700 border border-gray-200 font-medium py-2.5 px-4 rounded-lg transition-colors"
              >
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default PasswordManagementModal;
